import TransportsUtil from './transports-util';

const ComplianceState = {
    Compliant: 1,
    CompliantWithWarnings: 2,
    NoneCompliant: 3,
    Alarm: 4,
};

export default class Transports {
    constructor() {
        this.unitId = null;
        this.unitName = null;
        this.start = null;
        this.end = null;
        this.startTemp = null;
        this.complianceStart = null;
        this.complianceEnd = null;
        this.warnings = [];
        this.complianceState = null;
    }

    setComplianceState(state) {
        // Higher numbers = higher state severity. You can never downgrade.
        if (!this.complianceState || this.complianceState < state) {
            this.complianceState = state;
        }
    }

    applyWarningIfNotPresent(warning) {
        let warningExists = false;
        for (let i = 0; i < this.warnings.length; i += 1) {
            if (this.warnings[i].type === warning.type && this.warnings[i].critical === warning.critical) {
                warningExists = true;
            }
        }

        if (!warningExists) {
            this.warnings.push(warning);
        }
    }

    style() {
        const style = {};
        if (this.complianceState === ComplianceState.Compliant) {
            style.color = 'green';
        } else if (this.complianceState === ComplianceState.CompliantWithWarnings) {
            style.color = 'orange';
        } else if (this.complianceState === ComplianceState.NoneCompliant) {
            style.color = 'grey';
        } else if (this.complianceState === ComplianceState.Alarm) {
            style.color = 'red';
        }

        return style;
    }

    statusTooltip() {
        if (this.complianceState === ComplianceState.Compliant) {
            return 'TRANSPORT.COMPLIANT';
        } else if (this.complianceState === ComplianceState.CompliantWithWarnings) {
            return 'TRANSPORT.COMPLIANTWITHWARNINGS';
        } else if (this.complianceState === ComplianceState.NoneCompliant) {
            return 'TRANSPORT.NONECOMPLIANT';
        } else if (this.complianceState === ComplianceState.Alarm) {
            return 'TRANSPORT.ALARM';
        }

        return 'Status never set';
    }

    startLocal() {
        return TransportsUtil.unixToLocalTime(this.start);
    }

    endLocal() {
        return TransportsUtil.unixToLocalTime(this.end);
    }

    compliancePeriod() {
        if (this.complianceStart && !this.complianceEnd) {
            return 'TRANSPORTS.ONGOING';
        } else if (!this.complianceStart && this.complianceEnd) {
            return 'TRANSPORT.NEVEROK';
        } else if (this.complianceStart && this.complianceEnd) {
            return TransportsUtil.unixToLocalTime(this.complianceStart) + ' - ' + TransportsUtil.unixToLocalTime(this.complianceEnd);
        }
        return '';
    }

    firstWarning() {
        return this.warnings.length > 0 ? this.warnings[0].message : '';
    }

    graphStart() {
        return TransportsUtil.graphStart(this);
    }

    graphEnd() {
        return TransportsUtil.graphEnd(this);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/transports/Transport.js